import * as React from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper
} from "@material-ui/core";
import { ShowShareTable } from 'src/component/shared';

// tslint:disable-next-line:no-empty-interface
export interface IMarketCategoryThirtyDaysBillingEvolutionModalProps {
    categoriesVolumeArrayProp: string[],
    data: any[],
    loading: boolean
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketCategoryThirtyDaysBillingEvolutionModalState {
  dialogOpen: boolean;
}

export class MarketCategoryThirtyDaysBillingEvolutionModal extends React.Component<IMarketCategoryThirtyDaysBillingEvolutionModalProps, 
    IMarketCategoryThirtyDaysBillingEvolutionModalState> {
    constructor(props: IMarketCategoryThirtyDaysBillingEvolutionModalProps) {
        super(props);
        this.state = {
            dialogOpen: false
        };
    }

    public render() {
        return this.dataToRend(this.props.data, this.props.loading);
    }

    private dataToRend (data:any[], loading:any) {

        return (
            <div>
                <Button onClick={this.handleDialogOpen} color="primary">
                    Ver Mais
                </Button>
                <Dialog
                    fullScreen={true}
                    open={this.state.dialogOpen}
                    onClose={this.handleDialogClose}
                    aria-labelledby="share-table-modal-group-dialog-title"
                    aria-describedby="share-table-modal-group-dialog-description"
                    className="share-table-modal-dialog"
                >
                    <DialogTitle
                        className="share-table-modal-dialog-title"
                        id="share-table-modal-group-dialog-title"
                    >
                        Crescimento Volume - 30 Dias
                    </DialogTitle>
                    <DialogContent className="share-table-modal-dialog-content">
                        <Paper className="shared-share-sharetablemodal-block panel-block">
                            <Grid container={true} spacing={16}>
                                <ShowShareTable data={data} styleValue={1} />
                            </Grid>
                        </Paper>
                    </DialogContent>
                    <DialogActions className="share-table-modal-actions">
                        <Button
                            className="filter-dialog-close"
                            onClick={this.handleDialogClose}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

  private handleDialogOpen = () => {
    this.setState({ dialogOpen: true });
  };

  private handleDialogClose = () => {
    this.setState({ dialogOpen: false });
  };
}



// WEBPACK FOOTER //
// ./src/component/market/general/categories/thirty-days/billing-evolution/modal/MarketCategoryThirtyDaysBillingEvolutionModal.tsx